/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useRef } from "react";
import {
  I2cInput,
  I2cRadioButton,
  I2cRadioGroup,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
  I2cTooltip,
  I2cIcon,
  I2cTextarea,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import { validationSchema } from "./validationSchema";
import NewMigrationForm from "./NewMigrationForm";
import DataMigeration from "./DataMigerations";
import NewProgamForm from "./NewProgramForm";

import {
  credit_programType,
  setupType,
} from "./FieldsListingLabels";
import TooltipIcon from "../../../Components/SharedComponent/TooltipIcon/TooltipIcon";

const ProgramInfo = ({
  type,
  setFormValidStates,
  setAddFormData,
  addFormData,
  formDataJson,
  isFetching,
}) => {
  const checkboxRef = useRef(null);

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      pi_program_name: "",
      pi_program_type: [],
      pi_program_type_other: "",
      pi_proposition_value: "",
      pi_segment_value: "",
      pi_setup_type: "new-program",
      pi_type_of_migration: "",
      pi_type_of_processor_name: "",
      pi_current_processor_name: "",
      pi_key_component_custodians: [],
      pi_key_component_custodians_other: "",
      pi_data_migration_attributes: [],
      pi_data_migration_attributes_other: "",
      pi_migration_type: "",
      pi_ecount_1: "",
      pi_ecount_2: "",
      pi_ecount_3: "",
      pi_ecount_4: "",
      pi_evalue_1: "",
      pi_evalue_2: "",
      pi_evalue_3: "",
      pi_evalue_4: "",
      pi_evolume_1: "",
      pi_evolume_2: "",
      pi_evolume_3: "",
      pi_evolume_4: "",
    },
  });

  const fields = [
    "pi_program_name",
    "pi_program_type",
    "pi_program_type_other",
    "pi_proposition_value",
    "pi_segment_value",
    "pi_setup_type",
    "pi_type_of_migration",
    "pi_type_of_processor_name",
    "pi_current_processor_name",
    "pi_key_component_custodians",
    "pi_key_component_custodians_other",
    "pi_data_migration_attributes",
    "pi_data_migration_attributes_other",
    "pi_migration_type",
    "pi_ecount_1",
    "pi_ecount_2",
    "pi_ecount_3",
    "pi_ecount_4",
    "pi_evalue_1",
    "pi_evalue_2",
    "pi_evalue_3",
    "pi_evalue_4",
    "pi_evolume_1",
    "pi_evolume_2",
    "pi_evolume_3",
    "pi_evolume_4",
  ];
  const handleCheckboxChange = (value) => {
    let updatedData = methods.getValues("pi_program_type");
    if (updatedData.includes(value)) {
      updatedData = updatedData.filter((card) => card !== value);
    } else {
      updatedData.push(value);
    }
    if (!updatedData.includes(3)) {
      methods.setValue("pi_program_type_other", "");
    }
    methods.setValue("pi_program_type", updatedData);
    methods.trigger();
    handleValueChanges();
  };
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[1]["1_0"][field] ?? "");
      });
      methods.trigger();
    }
  }, [isFetching]);

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      1: {
        ...addFormData["1"],
        "1_0": { ...values },
      },
    });
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("9_1", true);
  };
  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("1_0", true);
    else setFormValidStates("1_0", false);
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div className="section-space">
          <div i2c-grid="grid gap-sm 4@md">
          <Controller
            name="pi_program_name"
            control={control}
            render={({ field }) => (
              <I2cInput
                {...field}
                className="single-input-field"
                placeholder="Program Name" 
                onI2cInput={(e) => {
                  const value = e.target.value;
                  field.onChange(value);
                  handleValueChanges();
                }}
                size="large"
                name={"pi_program_name"}
              >
              <span slot="label" className="organize-tooltip">
                <span className="custom-label"> Program Name</span>
                <I2cTooltip
                  content="Specify the name and URL communicated in the program marketing material"
                  placement="right-start"
                >
                  <I2cIcon
                    label="placement"
                    name="cs-linear-info"
                    color="#6B7080"
                  ></I2cIcon>
                </I2cTooltip>
              </span>
              </I2cInput>
            )}
          />
          {/* <ErrorMessage
            show={
              errors.pi_program_name &&
              methods.formState.touchedFields.pi_program_name
                ? true
                : false
            }
            message={errors.pi_program_name?.message ?? "Invalid input"}
          /> */}
          </div>
        </div>
        <div className="section-space">
          <span slot="label" className="organize-tooltip mb-16">
            <div className="sub-heading">
              Program Type 
            </div>
            <TooltipIcon content="The category selected here should coincide with the Program Type you have applied for (or received an approval for) from the Payment Network If you plan to launch a Creditor a Debit program, please ask your project manager to provide you the relevant CSD." />
          </span>
          <div className="single-field-wrapper">
            <Controller
              name="pi_program_type"
              control={control}
              render={({ field }) => (
                <I2cCheckboxGroup
                  ref={checkboxRef}
                >
                  <div i2c-grid="grid gap-sm">
                    {credit_programType.map((dma, index) => (
                      <I2cListItem
                        key={index}
                        i2c-grid="4@md 4@lg"
                        variant="receipt"
                        label={dma.label}
                        sublabel=""
                        value=""
                        type="checkbox"
                        checked={methods
                          .watch("pi_program_type")
                          .includes(dma.value)}
                        onI2cCheckboxClicked={() =>
                          handleCheckboxChange(dma.value)
                        }
                      >
                        <I2cCheckbox
                          slot="prefix"
                          name=""
                          value={dma.label}

                          filled
                          label=""
                          checked={methods
                            .watch("pi_program_type")
                            .includes(dma.value)}

                        />
                      </I2cListItem>
                    ))}
                  </div>
                </I2cCheckboxGroup>

              )}
            />
          </div>
          {methods.watch("pi_program_type").includes("other") && (
            <div i2c-grid="grid gap-sm">
              <div
                key={"pi_program_type_other"}
                i2c-grid="4@md"
              >
                <div className="single-field-wrapper mt-16">
                  <Controller
                    name="pi_program_type_other"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        label="Specify Program Type"
                        className="single-input-field"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          methods.trigger();
                          handleValueChanges();
                        }} 
                        placeholder="Enter Program Name"
                        size="large"
                        name={"pi_program_type_other"}
                      />
                    )}
                  />
                  {/* <ErrorMessage
                              show={
                                errors.pi_program_type_other &&
                                  methods.formState.touchedFields
                                    .pi_program_type_other
                                  ? true
                                  : false
                              }
                              message={
                                errors.pi_program_type_other?.message ??
                                "This Field is required"
                              }
                            /> */}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="section-space">
          <span slot="label" className="organize-tooltip mb-16">
            <div className="sub-heading">
              Program Description 
            </div>
            <TooltipIcon content="Enter a brief description here to help i2c team understand the business case." />
          </span>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid=" 6@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_proposition_value"
                  control={control}
                  render={({ field }) => (
                    <I2cTextarea
                      label="What is the value proposition, how is the program different
                      form other options in the market?"
                      {...field}
                      name="pi_proposition_value"
                      resize="none" 
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        methods.trigger();
                        handleValueChanges();
                      }}
                      placeholder="Enter Details"
                      rows={2}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pi_proposition_value &&
                      methods.formState.touchedFields.pi_proposition_value
                      ? true
                      : false
                  }
                  message={
                    errors.pi_proposition_value?.message ?? "Invalid input"
                  }
                />
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_segment_value"
                  control={control}
                  render={({ field }) => (
                    <I2cTextarea
                      label="Which segment of the market is this program going to be
                      targeted towards?"
                      {...field}
                      name="pi_segment_value"
                      resize="none" 
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        methods.trigger();
                        handleValueChanges();
                      }}
                      placeholder="Enter Details"
                      rows={2}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pi_segment_value &&
                      methods.formState.touchedFields.pi_segment_value
                      ? true
                      : false
                  }
                  message={errors.pi_segment_value?.message ?? "Invalid input"}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="section-space">
          <div className="sub-heading">
            Setup Type 
          </div>
          <div className="single-field-wrapper mb-16">
            <Controller
              name="pi_setup_type"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  label="Specify the setup type."
                  {...field}
                  name="pi_setup_type"
                  onI2cChange={(e) => {
                    const value = e.target.value;
                    if (value === "migration") {
                      methods.setValue("pi_ecount_1", "");
                      methods.setValue("pi_ecount_2", "");
                      methods.setValue("pi_ecount_3", "");
                      methods.setValue("pi_ecount_4", "");
                      methods.setValue("pi_evalue_1", "");
                      methods.setValue("pi_evalue_2", "");
                      methods.setValue("pi_evalue_3", "");
                      methods.setValue("pi_evalue_4", "");
                      methods.setValue("pi_evolume_1", "");
                      methods.setValue("pi_evolume_2", "");
                      methods.setValue("pi_evolume_3", "");
                      methods.setValue("pi_evolume_4", "");
                    }
                    else {
                      methods.setValue("pi_type_of_processor_name", "");
                      methods.setValue("pi_type_of_migration", "");
                      methods.setValue("pi_current_processor_name", "");
                      methods.setValue("pi_migration_type", "");
                      methods.setValue("pi_key_component_custodians", []);
                      methods.setValue("pi_key_component_custodians_other", "");
                      methods.setValue("pi_data_migration_attributes", []);
                      methods.setValue("pi_data_migration_attributes_other", "");
                    }
                    field.onChange(e);
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {setupType.map((cp, index) => (
                    <I2cRadioButton
                      key={index}
                      name="pi_setup_type"
                      checked={
                        methods.watch("pi_setup_type") ===
                        cp.toLocaleLowerCase().replace(" ", "-")
                      }
                      value={cp.toLocaleLowerCase().replace(" ", "-")}
                    >
                      {cp}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
            <ErrorMessage
              show={
                errors.pi_setup_type &&
                  methods.formState.touchedFields.pi_setup_type
                  ? true
                  : false
              }
              message={errors.pi_setup_type?.message ?? "Invalid input"}
            />
          </div>
          {methods.getValues("pi_setup_type") === "migration" && (
            <NewMigrationForm
              type={type}
              control={control}
              handleValueChanges={handleValueChanges}
              methods={methods}
              errors={errors}
            />
          )}
        </div>
        {methods.getValues("pi_setup_type") === "migration" && (
          <div className="section-space">
            <DataMigeration
              type={type}
              control={control}
              handleValueChanges={handleValueChanges}
              methods={methods}
              errors={errors}
            />
          </div>
        )}
        {methods.getValues("pi_setup_type") === "new-program" && (
          <div className="section-space">
            <NewProgamForm
              type={type}
              control={control}
              handleValueChanges={handleValueChanges}
              methods={methods}
              errors={errors}
            />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default ProgramInfo;
